import React, { useState,useEffect  } from "react";
import PropertyCard from "./PropertyCard";
import { motion } from "framer-motion";
import "./PropertiesHome.css";
import api from "../../Api.js";
import { getGalleries, getProperties } from "../../Services/Operations/ProductAPI.js";

const propertyData = [
  {
    status: "Available",
    title: "Serene Garden Villa",
    location: "Jubilee Hills, Hyderabad",
    beds: 3,
    baths: 4,
    area: 2400,
    price: "2.5 Cr",
    img: "https://gos3.ibcdn.com/dbc3b42b-fee5-43a9-8b21-7650f62224b5.jpeg",
  },
  {
    status: "Under Offer",
    title: "The Urban Crest",
    location: "Gachibowli, Hyderabad",
    beds: 2,
    baths: 2,
    area: 1800,
    price: "1.8 Cr",
    img: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Sold",
    title: "Skyline Penthouse",
    location: "Banjara Hills, Hyderabad",
    beds: 4,
    baths: 5,
    area: 4200,
    price: "5.1 Cr",
    img: "https://images.unsplash.com/photo-1501183638710-841dd1904471",
  },
  {
    status: "Available",
    title: "Lakeside Retreat",
    location: "Manikonda, Hyderabad",
    beds: 3,
    baths: 3,
    area: 2100,
    price: "2.1 Cr",
    img: "https://images.unsplash.com/photo-1560185127-6ed189bf02f4",
  },
  {
    status: "Available",
    title: "The Grandeur",
    location: "Hitech City, Hyderabad",
    beds: 5,
    baths: 4,
    area: 5500,
    price: "7.8 Cr",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSw-IGs85ivVTWA5S9HVWqMe52TAgD_vfe0aw&s",
  },
  {
    status: "Available",
    title: "Cityscape Lofts",
    location: "Gachibowli, Hyderabad",
    beds: 2,
    baths: 2,
    area: 1650,
    price: "1.5 Cr",
    img: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688",
  },
  {
    status: "Available",
    title: "Serene Garden Villa",
    location: "Jubilee Hills, Hyderabad",
    beds: 3,
    baths: 4,
    area: 2400,
    price: "2.5 Cr",
    img: "https://gos3.ibcdn.com/dbc3b42b-fee5-43a9-8b21-7650f62224b5.jpeg",
  },
  {
    status: "Under Offer",
    title: "The Urban Crest",
    location: "Gachibowli, Hyderabad",
    beds: 2,
    baths: 2,
    area: 1800,
    price: "1.8 Cr",
    img: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Sold",
    title: "Skyline Penthouse",
    location: "Banjara Hills, Hyderabad",
    beds: 4,
    baths: 5,
    area: 4200,
    price: "5.1 Cr",
    img: "https://images.unsplash.com/photo-1501183638710-841dd1904471",
  },
  {
    status: "Available",
    title: "Lakeside Retreat",
    location: "Manikonda, Hyderabad",
    beds: 3,
    baths: 3,
    area: 2100,
    price: "2.1 Cr",
    img: "https://images.unsplash.com/photo-1560185127-6ed189bf02f4",
  },
  {
    status: "Available",
    title: "The Grandeur",
    location: "Hitech City, Hyderabad",
    beds: 5,
    baths: 4,
    area: 5500,
    price: "7.8 Cr",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSw-IGs85ivVTWA5S9HVWqMe52TAgD_vfe0aw&s",
  },
  {
    status: "Available",
    title: "Cityscape Lofts",
    location: "Gachibowli, Hyderabad",
    beds: 2,
    baths: 2,
    area: 1650,
    price: "1.5 Cr",
    img: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688",
  },
];

const PropertiesHome = () => {
  const [search, setSearch] = useState("");
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

  const filteredData = projects.filter((p) =>
    p.location.toLowerCase().includes(search.toLowerCase())||
    p.property_name.toLowerCase().includes(search.toLowerCase())
  );

    // 🔹 Fetch projects from backend
  useEffect(() => {
    const fetchAllProjects = async () => {
      try {
        const response = await getProperties();
        console.log('getProperties',response);

         const response1 = await getGalleries();
         console.log('getGalleries',response1);
        
        setProjects(response.data.data || []);
      } catch (err) {
        console.error("Error fetching projects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllProjects();
  }, []);

  return (
    <div className="properties-wrapper" id="properties">

      {/* LEFT FILTER SIDEBAR */}
      <div className="sidebar">
        <h3>Filter By</h3>

        <div className="filter-group">
          <label>Search by Location</label>
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <button className="apply-btn">Apply Filters</button>
      </div>

      {/* RIGHT PROPERTIES LIST */}
      <div className="properties-right">
        <motion.h2
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          Explore Our Premium Properties
        </motion.h2>

        <p className="sub-text">
          Find your dream home from our curated selection of luxury properties.
        </p>

        <div className="properties-grid">
          {filteredData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.07 }}
            >
              <PropertyCard data={item} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PropertiesHome;
